import VideoYouTube from "./VideoYouTube";

/* Un vídeo de la pieza (campo `videos` del feed). Solo YouTube (decisión 2026-10-25). */
export default function Video({ v, nota, rotulo, portada }) {
  if (!v || v.retirado || !/youtu/.test(v.url || "")) return null;
  return <VideoYouTube url={v.url} autor={v.autor} titulo={v.titulo} fecha={v.fecha} nota={nota ?? v.nota} enfoque={v.enfoque} rotulo={rotulo} portada={portada} />;
}
